import { render, staticRenderFns } from "./CardAttachments.vue?vue&type=template&id=5711fed0&"
import script from "./CardAttachments.vue?vue&type=script&lang=js&"
export * from "./CardAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports